import React, { Component } from "react";
import { langCheck, OSnow } from "Pub/js/utils";
import success from "Assets/images/noviceGuide/success.png";
import "./end.less";

export default class End extends Component {
    render() {
        const { onAgain, onClose } = this.props;
        return <div className='novice-guide-modal'>
            <div className='content'>
                <img src={success} alt="" />
                {/* 恭喜，已完成所有的功能指引！ */}
                <p className='p1'>{langCheck('0000PUB-000574')}</p>
                <span >{langCheck('0000PUB-000575', false, null, [OSnow() === 'mac' ? 'Command+F1' : 'Ctrl+F1'])}</span>
                <p
                    className='p2'
                    onClick={onClose}
                >
                    {langCheck('0000PUB-000576')}
                </p>
                <span onClick={onAgain}>{langCheck('0000PUB-000577')}</span>
                <i className="iconfont icon-guanbi2 guide-close" onClick={onClose}></i>
            </div>
        </div>;
    }
}
